import {FC} from 'react';

import Condition from './Condition';

const ConditionTab: FC = () => <Condition />;

export default ConditionTab;
